
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import Popup from '@/components/utils/Popup.vue';

@Component({ components: { Popup } })
export default class ToastWithButtonPopup extends Vue {
  @Prop()
  message!: string;
  @Prop()
  buttonCaption!: string;

  buttonClick() {
    this.$emit('buttonClick');
  }
}
